<template>
  <v-container
    id="payment-management-users-list"
  >
    <v-row>
      <v-col
        cols="8"
        md=8
        class="breadcrumbs"
      >
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col
        cols="4"
        sm="4"
        class="text-right"
      >
        <app-modal-insert-payment
          :dialog="false"
          @onAddPayment="loadPayments"
        >
        </app-modal-insert-payment>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="2"
        sm="2"
      >
        <v-select
          v-model="filter.statusRelatorioId"
          item-text="text"
          item-name="value"
          :items="statusRelatorios"
          label="Status dos Relatórios"
        >
        </v-select>
      </v-col>

      <v-col
        cols="10"
        sm="10"
        class="text-right"
      >
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="loadPayments()"
        >
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payments"
          item-key="relatorioGestaoPagamentoId"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr
              :class="{ 'evidenciada': props.item.statusId === 1, 'evidenciar':  props.item.statusId === 2, 'rejeitada':  props.item.statusId === 0 }"
            >
              <td>
                <a @click="clickRow(props)">{{ props.item.relatorioGestaoPagamentoId }}</a>
              </td>
              <td>{{ props.item.usuario.nome }}</td>
              <td>{{ props.item.criacao | moment("DD/MM/YYYY") }}</td>
              <td>{{ props.item.horas }}</td>
              <td>
                <span v-if="props.item.statusId === 0">Não analisado</span>
                <span v-if="props.item.statusId === 1">Processo de Pagamento Aberto</span>
                <span v-if="props.item.statusId === 2">Reprovado</span>
              </td>
              <td>
                <v-btn v-if="props.item.statusId === 1" color="info" outlined text @click="relatorioSGF(props)">Relatório SGF</v-btn>
              </td>
              <td>
                <v-btn v-if="props.item.statusId === 1" color="info" outlined text @click="relatorioSGFEmail(props)">Receber E-mail</v-btn>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span>
              Nenhum processo de pagamento retornado
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <app-modal-analyse
      :dialog="openModal"
      :payload="selectedReport"
      @onCloseReport="onCloseModal"
    >
    </app-modal-analyse>

    <app-modal-report-sgf
      :dialog="openModalSGF"
      :payload="selectedReport"
      @onCloseReport="onCloseModalSGF"
    >
    </app-modal-report-sgf>
  </v-container>
</template>

<script>
import { AppModalInsertPayment, paymentReportManagementAPI } from '@/modules/payment-management'
import { mapActions } from 'vuex'
import AppModalAnalyse from './ModalAnalyse'
import AppModalReportSgf from './ModalReportSGF'

export default {
  components: {
    AppModalInsertPayment,
    AppModalAnalyse,
    AppModalReportSgf
  },
  data () {
    return {
      headers: [
        {
          text: '#',
          value: 'relatorioGestaoPagamentoId'
        },
        {
          text: 'Usuário',
          value: 'usuario.nome'
        },
        {
          text: 'Criação',
          value: 'criacao'
        },
        {
          text: 'Horas',
          value: 'horas'
        },
        {
          text: 'Situação',
          value: 'statusId'
        }
      ],
      headerReport: [
        {
          text: 'Título',
          value: 'relatorio.titulo'
        },
        {
          text: 'Município',
          value: 'relatorio.municipio.nome'
        },
        {
          text: 'Usuário',
          value: 'relatorio.usuario.nome'
        },
        {
          text: 'Tipo de Execução',
          value: 'relatorio.tipoExecucaoRelatorioId'
        },
        {
          text: 'Status',
          value: 'relatorio.statusRelatorioId'
        },
        {
          text: 'Criação',
          value: 'relatorio.criacao'
        },
        {
          text: 'Texto',
          value: 'relatorio.descricao'
        },
        {
          text: 'Tarefas',
          value: 'relatorio.tarefasString'
        },
        {
          text: 'Motivo da Rejeição',
          value: 'relatorio.motivoRejeicao'
        }
      ],
      payments: [],
      openModal: false,
      selectedReport: {},
      openModalSGF: false,
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: 'cidade'
        },
        {
          text: 'Meus Processos de Pagamento',
          disabled: true,
          href: 'gestao-pagamento/usuario/:id'
        }
      ],
      filter: {
        usuarioId: this.$route.params.id
      },
      statusRelatorios: [
        { text: 'Não Analisado', value: 0 },
        { text: 'Processo de Pagamento Aberto', value: 1 },
        { text: 'Rejeitado', value: 2 },
        { text: 'Todos', value: null }
      ]
    }
  },
  mounted () {
    this.loadPayments()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadPayments () {
      this.setLoading(true)
      paymentReportManagementAPI.listByUser(this.filter)
        .then(resp => {
          this.payments = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao listar processos de pagamento')
        })
    },
    onCloseModal () {
      this.openModal = false
    },
    clickRow (data) {
      this.selectedReport = data.item
      this.openModal = true
    },
    relatorioSGF (data) {
      this.selectedReport = data.item
      this.openModalSGF = true
    },
    onCloseModalSGF () {
      this.openModalSGF = false
    },
    relatorioSGFEmail (payload) {
      paymentReportManagementAPI.receiveEmail(payload.item.relatorioGestaoPagamentoId)
        .then(resp => {
          this.setLoading(false)
          this.$notification.success('E-mail enviado com sucesso')
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao enviar e-mail')
        })
    }
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
